import type { ApiEstimate } from "@/lib/api/types"

// Pre-check that triages a Pending estimate before the human confirms it:
// "clean" → safe to one-tap approve; "review" → worth opening first. The
// signals mirror what the shop already cares about — the $3k high-value line,
// structural involvement, and whether we can even reach the customer (no phone
// → the text-first follow-up can't run). This is what lets a 24/day shop
// batch-clear the clean ones and only eyeball the few flagged.

export type VerdictLevel = "clean" | "review"

export interface EstimateVerdict {
  level: VerdictLevel
  reasons: string[]
}

export const HIGH_VALUE_THRESHOLD = 3000

export function estimateVerdict(e: ApiEstimate): EstimateVerdict {
  const reasons: string[] = []
  if ((e.avg || 0) >= HIGH_VALUE_THRESHOLD) {
    reasons.push(`High value · $${Math.round(e.avg).toLocaleString("en-US")}`)
  }
  if ((e.lineItems ?? []).some((li) => li.structuralInvolvement === true)) {
    reasons.push("Structural involvement")
  }
  if (!e.vehicle?.customer?.phone) {
    reasons.push("No phone on file")
  }
  return { level: reasons.length > 0 ? "review" : "clean", reasons }
}

/** True when every reason is absent — safe for a batch "approve all clean". */
export function isCleanEstimate(e: ApiEstimate): boolean {
  return estimateVerdict(e).level === "clean"
}
